module.exports = __webpack_public_path__ + "static/golfreisen-5252ec37b7c35d81502e16a36df9e3b7.svg";